module.exports = __webpack_public_path__ + "img/registro-atividades.1bd2068a.svg";